import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { FooterComponent } from '@tsin-shared/components/footer/footer.component';
import { MainHeaderComponent } from '@tsin-shared/components/main-header/main-header.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MainHeaderComponent, FooterComponent, FormsModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  private router: Router = inject(Router);

  title = 'Touchstone EXAM Service';

  // Routes that render standalone, without the global topbar.
  private readonly headerlessRoutes = ['/account/activate-code'];

  // Whether the current route should show the global topbar.
  readonly showHeader = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => !this.isHeaderless(event.urlAfterRedirects))
    ),
    { initialValue: !this.isHeaderless(this.router.url) }
  );

  private isHeaderless(url: string): boolean {
    return this.headerlessRoutes.some((route) => url.startsWith(route));
  }
}
